import {
  SignatureLogicTypes,
  LogicOperators,
  UserTypes,
  SignatureLogicActions,
  UserPermissionTypes,
} from '@site-mate/dashpivot-shared-library';

export interface DropdownOptionData {
  label: string;
  value: string;
  disabled?: boolean;
  badgeText?: string;
}

export enum DropdownNames {
  Type = 'type',
  Operator = 'operator',
  Values = 'values',
  Action = 'action',
}

export const TypesDropdowns: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Permission Type',
    value: SignatureLogicTypes.Permission,
  },
  {
    label: 'User Type',
    value: SignatureLogicTypes.User,
  },
];

export const UserTypeOperatorsDropdown: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Equal to',
    value: LogicOperators.Equals,
  },
];

export const UserPermissionTypeOperatorsDropdown: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Equal to',
    value: LogicOperators.Equals,
  },
  {
    label: 'Equals to or higher than',
    value: LogicOperators.EqualsToOrHigherThan,
  },
];

export const UserTypeValuesDropdown: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Contributor',
    value: UserTypes.Contributor,
  },
  {
    label: 'Visitor',
    value: UserTypes.Visitor,
  },
];

export const UserPermissionValuesDropdown: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Team member',
    value: UserPermissionTypes.TeamMember,
  },
  {
    label: 'Team controller',
    value: UserPermissionTypes.TeamController,
  },
  {
    label: 'Project controller',
    value: UserPermissionTypes.ProjectController,
  },
  {
    label: 'Organisation controller',
    value: UserPermissionTypes.CompanyController,
  },
];

export const TypesToOperatorAndValuesMap: Readonly<{
  [key in SignatureLogicTypes]: {
    readonly operators: ReadonlyArray<Readonly<DropdownOptionData>>;
    readonly values: ReadonlyArray<Readonly<DropdownOptionData>>;
  };
}> = {
  [SignatureLogicTypes.User]: {
    operators: UserTypeOperatorsDropdown,
    values: UserTypeValuesDropdown,
  },
  [SignatureLogicTypes.Permission]: {
    operators: UserPermissionTypeOperatorsDropdown,
    values: UserPermissionValuesDropdown,
  },
};

export const ActionsDropdown: ReadonlyArray<Readonly<DropdownOptionData>> = [
  {
    label: 'Approval Sign',
    value: SignatureLogicActions.ApprovalSignature,
  },
  {
    label: 'Workflow Reset',
    value: SignatureLogicActions.ResetWorkflow,
    disabled: true,
    badgeText: 'Coming soon',
  },
];
